module.exports = __webpack_public_path__ + "img/recommended_02.5f0fcde4.webp";